/**
 * DOM utility functions for livechat widget components
 */

/**
 * Creates a DOM element with the specified attributes and innerHTML
 * @param {string} tag - HTML tag name
 * @param {Object} attributes - Object containing element attributes
 * @param {string} innerHTML - Inner HTML content (optional)
 * @returns {HTMLElement} Created DOM element
 */
export function createElement(tag, attributes = {}, innerHTML = "") {
  const element = document.createElement(tag);
  Object.entries(attributes).forEach(([key, value]) => {
    if (key === "style") {
      element.style.cssText = value;
    } else if (key === "className") {
      element.className = value;
    } else {
      element.setAttribute(key, value);
    }
  });
  if (innerHTML) element.innerHTML = innerHTML;
  return element;
}

export default { createElement };

